export const ROBOT_PORT_HTTP = 8009;
export const ROBOT_PORT_WSS = 8008;

export const IS_LOCAL = false;
export const IS_LOGGING_ON = false;